import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { DEFAULT_LOCALE, type Locale } from "./locales";

import enAssistant from "../../locales/en/assistant.json";
import enAuth from "../../locales/en/auth.json";
import enBoard from "../../locales/en/board.json";
import enCommon from "../../locales/en/common.json";
import enEditor from "../../locales/en/editor.json";
import enErrors from "../../locales/en/errors.json";
import enNav from "../../locales/en/nav.json";
import enPages from "../../locales/en/pages.json";

export { intlLocaleFor, SUPPORTED_LOCALES, type Locale } from "./locales";

/**
 * WSL Notion is English only: these bundles are every string the app shows,
 * and the source `types.d.ts` derives the typed t() keys from. (The pages
 * people write can be in any language — that is content, not UI.)
 *
 * Adding a namespace: create `locales/en/<ns>.json`, import it here, add it
 * to EN_RESOURCES and to `types.d.ts`.
 */
export const EN_RESOURCES = {
	assistant: enAssistant,
	auth: enAuth,
	board: enBoard,
	common: enCommon,
	editor: enEditor,
	errors: enErrors,
	nav: enNav,
	pages: enPages,
} as const;

/** The active locale for anything outside React: always English. */
export function currentLocale(): Locale {
	return DEFAULT_LOCALE;
}

/** Runs before the first render (main.tsx) so no frame paints untranslated. */
export async function initI18n(): Promise<void> {
	await i18n.use(initReactI18next).init({
		lng: DEFAULT_LOCALE,
		fallbackLng: DEFAULT_LOCALE,
		ns: Object.keys(EN_RESOURCES),
		defaultNS: "common",
		resources: { en: EN_RESOURCES },
		interpolation: { escapeValue: false }, // React escapes already
		react: { useSuspense: false }, // init awaits the bundles instead
		returnNull: false,
	});
	document.documentElement.lang = DEFAULT_LOCALE;
}

export { i18n };
